import React, { useMemo } from 'react';
import styles from './SkillPaths.module.scss';
import { Doughnut } from 'react-chartjs-2';
import { Grid } from '@material-ui/core';
const options = (total) => ({
  plugins: {
    tooltip: {
      enabled: total > 0,
      callbacks: {
        label: function (context) {
          return ` ${context?.label}: ${context?.formattedValue}%`;
        },
      },
    },
    legend: {
      display: false,
    },
  },
  animation: {
    duration: 1,
  },
  maintainAspectRatio: false,
  cutout: '70%',
  radius: '100%',
  cutoutPercentage: 10,
});
const RepSkillPathChart = ({ title = '', progress = {} }) => {
  const data = useMemo(() => {
    const fetchChartData = (progress) => {
      if (progress?.total_skill_paths) {
        return [progress?.percentage_completed, progress?.percentage_pendings];
      } else {
        return [1];
      }
    };

    const colors = progress?.total_skill_paths === 0 ? ['#e3e3e3'] : ['#63d2ab', '#ECEFF1'];

    return {
      labels: ['Completed', 'Pending'],
      datasets: [
        {
          label: '',
          data: fetchChartData(progress),
          backgroundColor: colors,
          borderColor: colors,
          hoverBorderColor: colors,
          hoverBackgroundColor: colors,
          hoverBorderWidth: 0,
          hoverBorderRadius: 0,
          hoverOffset: 6,
          borderWidth: 1,
        },
      ],
    };
  }, [progress]);
  return (
    <div className={styles.progressChart}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLine1}>
          <span className={styles.headerPeriod}>Progress</span>
          <span className={styles.headerPeriod}>In the last year</span>
        </div>
        <span className={styles.headerTitle}>{title}</span>
      </div>
      <div className={styles.bodyChart}>
        <Grid item xs={12} md={12} className={styles.chartDatasets}>
          <ul className="listUnstyled">
            <li className={styles.completed}>
              Completed - <strong>{progress?.total_skill_paths_completed}</strong>
            </li>
            <li className={styles.yetToStart}>
              Pending - <strong>{progress?.total_skill_paths_pendings}</strong>
            </li>
          </ul>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          style={{ height: '200px', position: 'relative', marginTop: '1.5rem' }}
        >
          <div className={styles.totalContainer}>
            <h6 className="heading1">{progress?.total_skill_paths}</h6>
            <p className="paragraph">Skill Paths</p>
          </div>
          <Doughnut data={data} options={options(progress?.total_skill_paths)} />
        </Grid>
      </div>
    </div>
  );
};

export default RepSkillPathChart;
